import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';

import { RootState } from '@root/app.state';
import * as RouterActions from '@platform/router.actions';
import { go } from '@platform/router.actions';
import { RouteGuard } from '@platform/routing/route.guard';
import { RouteData } from '@platform/routing/route.model';

import { firstValueFrom } from 'rxjs';
import { AuthorizeService } from './authorize.service';
import { extractParams } from './params-helper';

@Injectable({
  providedIn: 'root',
})
export class AuthorizeGuard implements RouteGuard {
  constructor(
    private authorizeService: AuthorizeService,
    private store$: Store<RootState>,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    this.store$.dispatch(RouterActions.setPath({ path: state.url }));
    const isAuthorized = await this.isAuthorized(route);
    if (!isAuthorized) {
      this.store$.dispatch(go({ path: ['unauthorized'] }));
    }

    return isAuthorized;
  }

  async canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    this.store$.dispatch(RouterActions.setPath({ path: state.url }));
    const isAuthorized = await this.isAuthorized(childRoute);
    if (!isAuthorized) {
      this.store$.dispatch(go({ path: ['unauthorized'] }));
    }

    return isAuthorized;
  }

  async isAuthorized(route: ActivatedRouteSnapshot): Promise<boolean> {
    const routeData: RouteData = route.data;
    if (!routeData.authorize) {
      return true;
    }

    const values = extractParams(route.root);
    for (const policy of routeData.authorize.policies) {
      const isAuthorized = await firstValueFrom(this.authorizeService.isAuthorized(policy, values));
      if (!isAuthorized) {
        return false;
      }
    }

    return true;
  }
}
